import { IconCheck } from 'src/assets';
import clsx from 'clsx';
import styles from './index.module.scss';

export type Lang = {
  key: string;
  name: string;
  nativeName: string;
}

type LangOptionListProps = {
  langList: Lang[];
  activeKey: string;
  onChange: (lang: Lang) => void;
}

const LangOptionList = (props: LangOptionListProps) => {
  const {
    langList,
    activeKey,
    onChange,
  } = props;

  const isFirefix = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;

  return (
    <div className={clsx(
      styles["lang_option_list_wrapper"],
      isFirefix ? "custom_firefox_scrollbar" : "custom_other_scrollbar"
    )}>
      <ul className={styles["lang_option_list"]}>
        {langList.map(item => (
          <li 
            key={item.key} 
            className={clsx(
              styles["lang_option_item"], 
              activeKey === item.key && styles["active"]
            )}
          >
            <button onClick={() => onChange(item)}>
              <div className={styles["name_wrapper"]}>
                <span className={styles["name"]}>{item.name}</span>
                <span className={styles["native_name"]}>{item.nativeName}</span>
              </div>

              {activeKey === item.key && (
                <IconCheck />
              )}
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default LangOptionList;